import { URLS } from '../../constants';
import apiClient from '../client';

const getLongFormApi = {
  getLongForm: () => apiClient.post(URLS.getAllLongForm, {}),
};

export default getLongFormApi;
